module.exports = __webpack_public_path__ + "media/images/form-background-bottom-58b7fb03.png";